import type { ApplicationSettingTheme, FilterBlockItemConfig } from '@lighthouse/core'
import { type FilterBlockConfig, FilterBlockMode, FilterSelectWay, FilterWay, NumberRangeMode } from '@lighthouse/core'
import { dateRangeVariableSystemNameMap, TEXT_FONT_NORMAL, themeBlockDesignConfig } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'

/**
 * 生成筛选器block的配置
 *
 * @returns {FilterBlockConfig}
 */
export const generateFilterBlock = (mainBreakPoint: string, theme: ApplicationSettingTheme): FilterBlockConfig => {
    const filterBlockLightDesignConfig = themeBlockDesignConfig('filter', theme).LIGHT
    return {
        mode: FilterBlockMode.normal,
        filterItems: [],
        showLabel: true,
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            },
            font: {
                fontFamily: TEXT_FONT_NORMAL
            },
            design: {
                theme: 'LIGHT',
                ...filterBlockLightDesignConfig?.design
            },
            hoverStyle: filterBlockLightDesignConfig?.hoverStyle,
            activeStyle: filterBlockLightDesignConfig?.activeStyle,
            disabledStyle: filterBlockLightDesignConfig?.disabledStyle
        },
        breakPoints: []
    }
}

export const getFilterBlockItem = (type?: FilterWay): FilterBlockItemConfig => {
    const getConfig = (type?: FilterWay) => {
        if (type === FilterWay.numberFilter) {
            return {
                numberRangeMode: NumberRangeMode.disable
            }
        }
        if (type === FilterWay.cascadeFilter) {
            return {
                fieldPointer: 'ID'
            }
        }
        if (type === FilterWay.dateFilter) {
            return {
                dateVariables: Object.keys(dateRangeVariableSystemNameMap)
            }
        }
        return {}
    }

    return {
        id: nanoid(),
        title: '筛选项',
        filterWay: type || FilterWay.textFilter,
        selectWay: FilterSelectWay.singleSelect,
        ...getConfig(type)
    }
}
